import { PassoPasso } from "./style";
import Risco from "../../../../assets/risco.svg";

function PassoPassoComponent() {
  return (
    <PassoPasso id="passopasso">
      <div id="description">
        <div id="desc-two">
          <p id="paragraph-desc-two">
            * Os passos 1 e 2 podem ter suas devolutivas em um único encontro.<br/>
            ** Os passos 3, 4 e 5 também podem ser feitos em um único encontro.<br/>
            *** Tudo será feito dentro da disponibilidade do cliente.
          </p>
          <span>Dê uma olhada nos processos abaixo 👇🏼</span>
        </div>
        <div id="desc-one">
          <span>focado em aprendizado rápido e eficiente!</span>
          <h1>Passo a Passo do trabalho..</h1>
          <img src={Risco} alt="" />
        </div>
      </div>
      <div id="solutions">
        <button className="buttons">
          <h3>passo 01</h3>
          <h3>teste de nivelamento</h3>
          <p>Teste Online e Entrevista.</p>
        </button>
        <button className="buttons">
          <h3>passo 02</h3>
          <h3>Consultoria comportamental</h3>
          <p>Mapeamento DISC.</p>
        </button>
        <button className="buttons">
          <h3>passo 03</h3>
          <h3>Entendimento</h3>
          <p>Apresentação do Processo.</p>
        </button>
        <button className="buttons">
          <h3>passo 04</h3>
          <h3>Planejamento</h3>
          <p>
            Definição de estratégias e o COMO, dentro das características de
            cada cliente.
          </p>
        </button>
        <button className="buttons">
          <h3>passo 05</h3>
          <h3>Recursos digitais</h3>
          <p>Apresentação da Plataforma Google e ajustes para seu uso.</p>
        </button>
        <button className="buttons">
          <h3>passo 06</h3>
          <h3>Aplicação do processo</h3>
          <p>Inicia-se o Primeiro Ciclo.</p>
        </button>
        <button className="buttons">
          <h3>passo 07</h3>
          <h3>Revisão do Processo</h3>
          <p>
            Comportamento, resultado, desempenho, ajustes de melhoria e
            reconhecimento.
          </p>
        </button>
        <button className="buttons">
          <h3>passo 08</h3>
          <h3>início do novo ciclo</h3>
          <p>
            Repete-se os passos 6 e 7 pelo tempo do programa até atingir o
            resultado.
          </p>
        </button>
      </div>
    </PassoPasso>
  );
}

export default PassoPassoComponent;
